import React, { PropTypes } from 'react';
import B from 'bem-cn';
import './index.scss';

import TechnologyScheme from './scheme';
import Tabs, { Tab } from '../tabs';

import { scrollToElement } from '../../utils/scroll';
import getStaticContent from '../../utils/getStaticContent';

const cl = B('Technology');

export default class Technology extends React.Component {
  constructor(props) {
    super(props);

    this.staticContent = getStaticContent('technology', props.currentPageName);

    this.tabItems = [
      this.staticContent.schemeTab.title,
      ...this.staticContent.tabs.map(item => item.title)
    ];
    this.state = {
      tabIdx: 0
    };
  }

  static propTypes = {
    passRef: React.PropTypes.func,
    currentPageName: PropTypes.string.isRequired
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState !== this.state) {
      return true;
    }
    return false;
  }

  onTabChange() {
    scrollToElement('#technology');
  }

  render() {
    return (
      <div className={cl} id="technology" ref={this.props.passRef}>
        <div className="container">
          <div className={cl('title')}>{this.staticContent.title}</div>
          <Tabs index={this.state.tabIdx} onChange={this.onTabChange}>
            {[
              <Tab
                key="schemeTab"
                label={this.staticContent.schemeTab.title}
                className={cl('schemeTab').toString()}
              >
                <TechnologyScheme cl={cl} staticContent={this.staticContent} />
              </Tab>,
              ...this.staticContent.tabs.map((item, itemIndex) => (
                <Tab
                  key={itemIndex + 1}
                  label={item.title}
                  className={cl('contentTab').toString()}
                >
                  <div dangerouslySetInnerHTML={{ __html: item.content }} />
                </Tab>
              ))
            ]}
          </Tabs>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src/components/technology/index.js